function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { decode as decodeBase64URL, encodeBase64, decodeBase64 } from '../runtime/base64url.js';
import { fromSPKI as importPublic } from '../runtime/asn1.js';
import { fromPKCS8 as importPrivate } from '../runtime/asn1.js';
import asKeyObject from '../runtime/jwk_to_key.js';
import { JOSENotSupported } from '../util/errors.js';
import formatPEM from '../lib/format_pem.js';
import isObject from '../lib/is_object.js';

function getElement(seq) {
  var result = [];
  var next = 0;

  while (next < seq.length) {
    var nextPart = parseElement(seq.subarray(next));
    result.push(nextPart);
    next += nextPart.byteLength;
  }

  return result;
}

function parseElement(bytes) {
  var position = 0;
  var tag = bytes[0] & 0x1f;
  position++;

  if (tag === 0x1f) {
    tag = 0;

    while (bytes[position] >= 0x80) {
      tag = tag * 128 + bytes[position] - 0x80;
      position++;
    }

    tag = tag * 128 + bytes[position] - 0x80;
    position++;
  }

  var length = 0;

  if (bytes[position] < 0x80) {
    length = bytes[position];
    position++;
  } else if (length === 0x80) {
    length = 0;

    while (bytes[position + length] !== 0 || bytes[position + length + 1] !== 0) {
      if (length > bytes.byteLength) {
        throw new TypeError('invalid indefinite form length');
      }

      length++;
    }

    var _byteLength = position + length + 2;

    return {
      byteLength: _byteLength,
      contents: bytes.subarray(position, position + length),
      raw: bytes.subarray(0, _byteLength)
    };
  } else {
    var numberOfDigits = bytes[position] & 0x7f;
    position++;
    length = 0;

    for (var i = 0; i < numberOfDigits; i++) {
      length = length * 256 + bytes[position];
      position++;
    }
  }

  var byteLength = position + length;
  return {
    byteLength: byteLength,
    contents: bytes.subarray(position, byteLength),
    raw: bytes.subarray(0, byteLength)
  };
}

function spkiFromX509(buf) {
  var tbsCertificate = getElement(getElement(parseElement(buf).contents)[0].contents);
  return encodeBase64(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}

function getSPKI(x509) {
  var pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '');
  var raw = decodeBase64(pem);
  return formatPEM(spkiFromX509(raw), 'PUBLIC KEY');
}

export function importSPKI(_x, _x2, _x3) {
  return _importSPKI.apply(this, arguments);
}

function _importSPKI() {
  _importSPKI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(spki, alg, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof spki !== 'string' || spki.indexOf('-----BEGIN PUBLIC KEY-----') !== 0)) {
              _context.next = 2;
              break;
            }

            throw new TypeError('"spki" must be SPKI formatted string');

          case 2:
            return _context.abrupt("return", importPublic(spki, alg, options));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _importSPKI.apply(this, arguments);
}

export function importX509(_x4, _x5, _x6) {
  return _importX.apply(this, arguments);
}

function _importX() {
  _importX = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(x509, alg, options) {
    var spki;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof x509 !== 'string' || x509.indexOf('-----BEGIN CERTIFICATE-----') !== 0)) {
              _context2.next = 2;
              break;
            }

            throw new TypeError('"x509" must be X.509 formatted string');

          case 2:
            _context2.prev = 2;
            spki = getSPKI(x509);
            _context2.next = 9;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](2);
            throw new TypeError('failed to parse the X.509 certificate', {
              cause: _context2.t0
            });

          case 9:
            return _context2.abrupt("return", importPublic(spki, alg, options));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 6]]);
  }));
  return _importX.apply(this, arguments);
}

export function importPKCS8(_x7, _x8, _x9) {
  return _importPKCS.apply(this, arguments);
}

function _importPKCS() {
  _importPKCS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(pkcs8, alg, options) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(typeof pkcs8 !== 'string' || pkcs8.indexOf('-----BEGIN PRIVATE KEY-----') !== 0)) {
              _context3.next = 2;
              break;
            }

            throw new TypeError('"pkcs8" must be PKCS#8 formatted string');

          case 2:
            return _context3.abrupt("return", importPrivate(pkcs8, alg, options));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _importPKCS.apply(this, arguments);
}

export function importJWK(_x10, _x11, _x12) {
  return _importJWK.apply(this, arguments);
}

function _importJWK() {
  _importJWK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(jwk, alg, octAsKeyObject) {
    var _a;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (isObject(jwk)) {
              _context4.next = 2;
              break;
            }

            throw new TypeError('JWK must be an object');

          case 2:
            alg || (alg = jwk.alg);

            if (!(typeof alg !== 'string' || !alg)) {
              _context4.next = 5;
              break;
            }

            throw new TypeError('"alg" argument is required when "jwk.alg" is not present');

          case 5:
            _context4.t0 = jwk.kty;
            _context4.next = _context4.t0 === 'oct' ? 8 : _context4.t0 === 'RSA' ? 14 : _context4.t0 === 'EC' ? 16 : _context4.t0 === 'OKP' ? 16 : 17;
            break;

          case 8:
            if (!(typeof jwk.k !== 'string' || !jwk.k)) {
              _context4.next = 10;
              break;
            }

            throw new TypeError('missing "k" (Key Value) Parameter value');

          case 10:
            octAsKeyObject !== null && octAsKeyObject !== void 0 ? octAsKeyObject : octAsKeyObject = jwk.ext !== true;

            if (!octAsKeyObject) {
              _context4.next = 13;
              break;
            }

            return _context4.abrupt("return", asKeyObject(_objectSpread(_objectSpread({}, jwk), {}, {
              alg: alg,
              ext: (_a = jwk.ext) !== null && _a !== void 0 ? _a : false
            })));

          case 13:
            return _context4.abrupt("return", decodeBase64URL(jwk.k));

          case 14:
            if (!(jwk.oth !== undefined)) {
              _context4.next = 16;
              break;
            }

            throw new JOSENotSupported('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');

          case 16:
            return _context4.abrupt("return", asKeyObject(_objectSpread(_objectSpread({}, jwk), {}, {
              alg: alg
            })));

          case 17:
            throw new JOSENotSupported('Unsupported "kty" (Key Type) Parameter value');

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _importJWK.apply(this, arguments);
}